import {useTranslation} from 'react-i18next';
import {IOptionType} from "../types/common";
import {IManualFinderFilterModel, IManualFinderModel} from "../types/manualFinder";
import {ExtractedItem} from "../utils/manualFinderUtils";

export const useManualFinderDefaultValues = () => {
    const {t} = useTranslation();

    return {
        extractedTypeDefault: {
            value: ExtractedItem.SpecialTools,
            label: t('Sidebar.SpecialTools')
        } as IOptionType,

        manualFinderFilterDefault: {
            threshold: 0.5,
            maxNumberOfManuals: 10,
            topKSpecialTools: 5,
            manufacturers: [],
            selectedManufacturers: [],
            itemMPOptions: [],
            extractOptions: [],
            selectedItemMP: null,
            checkedTools: []
        } as IManualFinderFilterModel,

        manualFinderPropsDefault: {
            extractedImages: [],
            manuals: [],
            manualsBasedOnImages: [],
            specialTools: []
        } as IManualFinderModel,
    };
};
